import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { VisitorBadgeStatusType } from '@/api';
import { badgeStatusLabel } from '../../../visitorStatus';

const SystemBadgeStatusField = forwardRef((props, ref) => {
  const { data: initial } = props;
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    fillValue: data => {
      data.status = data.status || [];
      data.status['badgeStatus'] = inputRef.current.value;
      return true;
    },
  }));

  return (
    <TextField
      select
      name={'status'}
      label={'Бейдж'}
      inputRef={inputRef}
      fullWidth
      margin='dense'
      variant='outlined'
      autoComplete='off'
      defaultValue={(initial.status && initial.status['badgeStatus']) || VisitorBadgeStatusType.NoBadge}
    >
      {Object.values(VisitorBadgeStatusType).map(v => (
        <MenuItem key={v} value={v}>
          {badgeStatusLabel(v)}
        </MenuItem>
      ))}
    </TextField>
  );
});

export default SystemBadgeStatusField;
